module.exports = __webpack_public_path__ + "img/logout.97928588.svg";